/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["code[_ngcontent-%COMP%]{display:block;margin-top:10px;background:#f2f4f8;padding:10px;border-radius:4px}legend[_ngcontent-%COMP%]{margin-top:25px}legend[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{background:0 0}.alert[_ngcontent-%COMP%]{margin-top:20px}.widget-preview[_ngcontent-%COMP%]{border:1px solid #eee}"];
export { styles as styles };
